export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_bmitzvah-91739f7ca1ce2448ed10843e43551bf7.jpg";